// src/pages/About.jsx
import React from "react";
import { Link } from "react-router";
import SEO from "../seo/Seo";
import Alexandria from "../media/City-of-Alexandria.webp";
import ArlingtonCounty from "../media/Arlington-County.webp";
import FairfaxCounty from "../media/Fairfax.webp";
import LoudonCounty from "../media/Loudoun-County.webp";
import PrinceWilliam from "../media/Prince William.webp";
import FallsChurch from "../media/Falls-Church.webp";
import CityFairfax from "../media/City-of-Fairfax.webp";
import Washington from "../media/Washington.webp";
import PrinceGeorge from "../media/Prince-George.webp";
import Chesapeak from "../media/Chesapeake.webp";
import Newport from "../media/Newport-News.webp";
import Norfolk from "../media/Norfolk.webp";
import Suffolk from "../media/Suffolk.webp";
import VirginiaBeach from "../media/Virginia-Beach.webp";
import TownVienna from "../media/Town of Vienna.webp";
import TownHerndon from "../media/Town-of-Herndon.webp";
import Montgomery from "../media/Montgomery-County.webp";
import AnneArundel from "../media/Anne-Arundel-County.webp";

export default function About() {
  const regions = [
    {
      city: "City of Alexandria",
      img: Alexandria,
    },
    {
      city: "Arlington County",
      img: ArlingtonCounty,
    },
    {
      city: "Fairfax County",
      img: FairfaxCounty,
    },
    {
      city: "Loudoun County",
      img: LoudonCounty,
    },
    {
      city: "Prince William County",
      img: PrinceWilliam,
    },
    {
      city: "City of Falls Church",
      img: FallsChurch,
    },
    {
      city: "City of Fairfax",
      img: CityFairfax,
    },
    {
      city: "Washington D.C.",
      img: Washington,
    },
    {
      city: "Prince George’s County",
      img: PrinceGeorge,
    },
    {
      city: "Chesapeake",
      img: Chesapeak,
    },
    {
      city: "Newport News",
      img: Newport,
    },
    {
      city: "Norfolk",
      img: Norfolk,
    },
    {
      city: "Suffolk",
      img: Suffolk,
    },
    {
      city: "Virginia Beach",
      img: VirginiaBeach,
    },
    {
      city: "Town of Vienna",
      img: TownVienna,
    },
    {
      city: "Town of Herndon",
      img: TownHerndon,
    },
    {
      city: "Montgomery County",
      img: Montgomery,
    },
    {
      city: "Anne Arundel County",
      img: AnneArundel,
    },
  ];

  return (
    <>
      <SEO
        title="About Us"
        description="Learn more about Innovative Land Developers: our mission, values, and the regions we serve across the DMV and Hampton Roads."
        keywords="land development, civil engineering, surveying, DMV, Hampton Roads, Virginia, about InnovativeLD"
        image="/about-hero.jpg"
        url="https://www.innovativeld.com/about"
      />

      {/* HERO */}
      <section className="relative h-[70vh] w-full bg-primario overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80"
          alt="Civil engineering and land development"
          className="absolute inset-0 w-full h-full object-cover opacity-60 blur-sm"
        />
        <div className="max-w-6xl p-10 mx-auto absolute inset-0 flex flex-col justify-center items-end">
          <h1 className="text-5xl lg:text-8xl font-bold text-secundario font-primaria">
            About Us
          </h1>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section className="py-16 px-6 lg:px-16 bg-primario font-secundaria text-2xl">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-secundario font-primaria">
              Our mission is greater than delivering precise engineering
            </h2>
            <p className="text-white leading-relaxed mb-4">
              We create resilient places that compound in value and meaning. We
              approach every project with analytical discipline, efficiency, and
              respect for the trust placed in us. We transform complex
              challenges into outcomes developers can act on, communities can
              thrive in, and future generations can rely on.
            </p>
            {/* <p className="text-blue-50 leading-relaxed mb-4">
              We approach every project with clarity, efficiency, and a deep
              respect for the trust our clients place in us. Guided by integrity
              and driven by progress, we turn complex site challenges into
              streamlined, build-ready outcomes.
            </p> */}
            {/* <p className="text-blue-50 leading-relaxed">
              With expertise in site design, permitting, and surveying, our team
              ensures your projects move forward efficiently and
              cost-effectively.
            </p> */}
          </div>
          <div className="h-full">
            <img
              src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Our engineering team at work"
              className="rounded-lg shadow-md object-cover h-full w-full"
            />
          </div>
        </div>
      </section>

      {/* VALUES SECTION */}
      <section className="py-12 px-6 lg:px-16 bg-secundario">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl lg:text-8xl font-bold mb-8 font-primaria">
            Our Core Values
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-2xl lg:text-4xl font-semibold mb-3 font-primaria">
                Simplicity
              </h3>
              <p className="text-gray-600 text-xl">
                Streamlined processes that minimize downtime and prevent rework.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-2xl lg:text-4xl font-semibold mb-3 font-primaria">
                Communication
              </h3>
              <p className="text-gray-600 text-xl">
                Transparent, proactive updates to keep all stakeholders aligned.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-2xl lg:text-4xl font-semibold mb-3 font-primaria">
                Dedication
              </h3>
              <p className="text-gray-600 text-xl">
                A relentless commitment to protecting budgets, schedules, and
                investor confidence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* WHERE WE WORK */}
      <section className="py-16 px-6 lg:px-16 bg-primario">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl lg:text-8xl font-bold mb-6 text-secundario font-primaria">
            Where We Work
          </h2>
          <p className="text-blue-50 mb-8 text-2xl">
            Innovative Land Developers proudly serves communities across the DMV
            and Hampton Roads regions. From urban infill projects to expansive
            residential lots and commercial developments, we deliver customized
            civil engineering and surveying solutions throughout:
          </p>

          <div
            className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
            style={{ contentVisibility: "auto", containIntrinsicSize: "160px" }}
          >
            {regions.map((region, i) => (
              <div
                key={i}
                className="relative h-40 rounded-lg overflow-hidden shadow-md group"
              >
                <img
                  src={region.img}
                  alt={`View of ${region.city}`}
                  className="absolute inset-0 w-full h-full object-cover "
                  loading="lazy"
                  decoding="async"
                  width={600}
                  height={400}
                />
                <div className="absolute inset-0 bg-primario bg-opacity-50 flex items-center justify-center">
                  <span className="text-secundario font-semibold text-lg text-center px-2 font-primaria">
                    {region.city}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-6 lg:px-16 bg-primario text-secundario text-center">
        <h2 className="text-4xl lg:text-6xl font-bold mb-4 font-primaria">
          Building Better Communities, Together
        </h2>
        <p className="max-w-2xl lg:text-2xl mx-auto mb-8 text-blue-100">
          Whether you’re a homeowner, builder, or developer, our team is ready
          to provide innovative, efficient, and sustainable land development
          solutions tailored to your needs.
        </p>
        <Link
          to="/consultation"
          className="bg-secundario text-primario font-semibold px-6 py-3 rounded-full shadow hover:bg-yellow-300 transition text-xl font-primaria"
        >
          Schedule a Consultation
        </Link>
      </section>
    </>
  );
}
